// extracted by mini-css-extract-plugin
module.exports = {"primaryFilters":"JobAdsFilters_primaryFilters__J6P69"};